// extracted by mini-css-extract-plugin
export default {"container":"PreviewContainer_container__sLLTB","textCenter":"PreviewContainer_textCenter__wX9fy"};